export const formatPhoneNumber = phone => {
  try {
    return `${phone.slice(0,3)}-${phone.slice(3,6)}-${phone.slice(6)}`;
  } catch (error) {
    return null;
  }
};
